function view (path) {
  return () => import(/* webpackChunkName: 'landing' */ '@/views/landing/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

/**
 * Landing Page Routes
 *
 * Architecture:
 * - Home section routes use clean URLs (/home/faqs, /home/contact)
 * - About has its own page
 * - Each service has its own dedicated route
 * - "More" section pages have their own routes
 */
const RLanding = [
  // Home - redirect root to /home
  {
    path: '',
    name: 'landing.redirect',
    redirect: { name: 'landing.home' },
    meta: { layout: 'landing' }
  },
  {
    path: '/home',
    component: view('Home'),
    name: 'landing.home',
    meta: { layout: 'landing' }
  },
  {
    path: '/home/faqs',
    component: view('Home'),
    name: 'landing.home.faqs',
    meta: { layout: 'landing' }
  },
  {
    path: '/home/contact',
    component: view('Home'),
    name: 'landing.home.contact',
    meta: { layout: 'landing' }
  },
  {
    path: '/home/book-appointment',
    component: view('Home'),
    name: 'landing.home.book-appointment',
    meta: { layout: 'landing' }
  },

  // About Page
  {
    path: '/about',
    component: view('about/About'),
    name: 'landing.about',
    meta: { layout: 'landing' }
  },

  // Service Pages - each has its own route
  {
    path: '/services/student-welfare',
    component: view('services/StudentWelfare'),
    name: 'landing.services.student-welfare',
    meta: { layout: 'landing' }
  },
  {
    path: '/services/student-development',
    component: view('services/Leadership'),
    name: 'landing.services.student-development',
    meta: { layout: 'landing' }
  },
  {
    path: '/services/health-wellness',
    component: view('services/Health'),
    name: 'landing.services.health-wellness',
    meta: { layout: 'landing' }
  },
  {
    path: '/services/counseling',
    component: view('services/Counseling'),
    name: 'landing.services.counseling',
    meta: { layout: 'landing' }
  },
  {
    path: '/services/career',
    component: view('services/Career'),
    name: 'landing.services.career',
    meta: { layout: 'landing' }
  },
  {
    path: '/services/community',
    component: view('services/Community'),
    name: 'landing.services.community',
    meta: { layout: 'landing' }
  },
  {
    path: '/services/lost-found',
    component: view('services/LostFound'),
    name: 'landing.lost-found',
    meta: { layout: 'landing' }
  },
  {
    path: '/services/records',
    component: view('services/Records'),
    name: 'landing.services.records',
    meta: { layout: 'landing' }
  },

  // More Section Pages
  {
    path: '/programs',
    component: view('more/Programs'),
    name: 'landing.programs',
    meta: { layout: 'landing' }
  },
  {
    path: '/support',
    component: view('more/Support'),
    name: 'landing.support',
    meta: { layout: 'landing' }
  },
  {
    path: '/policies',
    component: view('more/Policies'),
    name: 'landing.policies',
    meta: { layout: 'landing' }
  },
  {
    path: '/events',
    component: view('more/Events'),
    name: 'landing.events',
    meta: { layout: 'landing' }
  }
]

export {
  RLanding
}
